<template>
  <div class="row">
    <div class="col-xs-12">
      <div v-if="error" class="alert alert-danger">{{ error }}</div>
      <div v-else-if="loading" class="text-center">
        <i class="fa fa-circle-o-notch fa-spin fa-2x"></i>
      </div>
      <MarketingBreakdownTable
        v-else-if="report"
        title="How Customers Said They Heard About You"
        test-id="marketing-report-customer-sources"
        share-label="Share of Answers"
        :rows="report.by_source"
        :name-columns="columns"
        empty-text="No customer with an order in these dates has answered this question yet."
      >
        <p class="text-muted" data-testid="marketing-report-customer-sources-explanation">
          These are customers' own answers to "How did you hear about us?", so they can differ from what the
          rest of this page recorded automatically. This section also counts orders your staff enter and orders
          students place in their portal. The rest of this page counts shop orders only, so the totals won't match.
        </p>
        <p data-testid="marketing-report-customer-sources-answered">
          {{ report.summary.answered_orders.toLocaleString() }} of {{ report.summary.orders.toLocaleString() }}
          orders in these dates are from customers who answered.
        </p>
      </MarketingBreakdownTable>
    </div>
  </div>
</template>

<script>
import MarketingBreakdownTable from './MarketingBreakdownTable.vue';

// Its own read, so a school with no tracked orders yet still sees what customers said.
export default {
  name: 'MarketingCustomerSources',
  components: { MarketingBreakdownTable },
  props: {
    filters: { type: Object, required: true }
  },
  data: function() {
    return {
      report: null,
      loading: true,
      error: '',
      latestRequest: 0,
      columns: [{ key: 'source', label: 'Answer' }, { key: 'customers', label: 'Customers' }]
    };
  },
  watch: {
    filters: {
      handler: function() {
        this.fetchReport();
      },
      deep: true
    }
  },
  created: function() {
    this.fetchReport();
  },
  methods: {
    fetchReport: function() {
      var vm = this;
      var request = ++vm.latestRequest;
      vm.loading = true;
      vm.error = '';

      vm.$store.dispatch('GET_CUSTOMER_SOURCES', vm.filters)
        .then(function(report) {
          if (request === vm.latestRequest) {
            vm.report = report;
            vm.loading = false;
          }
        })
        .catch(function() {
          if (request === vm.latestRequest) {
            vm.error = "Failed to load customers' answers.";
            vm.loading = false;
          }
        });
    }
  }
};
</script>
